var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"flex flex-col items-center justify-center gap-x-4 gap-y-[80px] sm:grid sm:flex-none sm:grid-cols-2 md:gap-x-8 lg:grid-cols-3 lg:gap-x-6 xl:grid-cols-4 2xl:gap-y-[100px] 3xl:gap-x-8"},_vm._l((8),function(i){return _c('li',{key:i,staticClass:"w-full max-w-[330px] sm:max-w-full"},[_c('AppSkeletonCard')],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }